import AuthenticationContext from 'adal-angular'
import { getAdInfo } from '@/api/apps/request'

const config = {
  redirectUri: `${window.location.origin}/adLogin`,
  cacheLocation: 'localStorage',
  postLogoutRedirectUri: `${window.location.origin}/login`,
}

export default {
  authenticationContext: null,

  /**
   * @return {Promise}
   */
  async getConfig () {
    if (!config.tenantId) {
      const response = await getAdInfo()
      config.tenantId = response.tenantId
      config.clientId = response.clientId
    }
    return config
  },
  async initContext () {
    if (!this.authenticationContext) {
      const config = await this.getConfig()
      this.authenticationContext = new AuthenticationContext(config)
    }
  },
  async isBack () {
    await this.initContext()
    return this.authenticationContext.isCallback(window.location.hash) || window.self !== window.top
  },
  async setAfterLoginToUrl () {
    const context = this.authenticationContext
    context._saveItem(context.CONSTANTS.STORAGE.ANGULAR_LOGIN_REQUEST, config.redirectUri)
  },
  async initialize () {
    await this.initContext()

    // login just finished
    if (await this.isBack()) {
      return this.authenticationContext.handleWindowCallback()
    }
    const user = this.authenticationContext.getCachedUser()
    if (user) {
      return user
    }
    this.setAfterLoginToUrl()
    this.authenticationContext.login()
  },
  /**
   * @return {Promise.<String>} A promise that resolves to an ADAL token for resource access
   */
  async acquireToken () {
    if (!this.hasUserFile()) await this.initialize()
    return new Promise((resolve, reject) => {
      const clientId = config.clientId
      this.authenticationContext.acquireToken(clientId, (error, token) => {
        if (error || !token) {
          return reject(error)
        } else {
          return resolve(token)
        }
      })
    })
  },
  /**
   * Issue an interactive authentication request for the current user and the api resource.
   */
  acquireTokenRedirect (clientId) {
    this.authenticationContext.acquireTokenRedirect(clientId)
  },
  /**
   * @return {Boolean} Indicates if there is a valid, non-expired access token present in localStorage.
   */
  isAuthenticated () {
    // getCachedToken will only return a valid, non-expired token.
    if (this.authenticationContext && this.authenticationContext.getCachedToken(config.clientId)) { return true }
    return false
  },
  hasUserFile () {
    return this.authenticationContext
  },
  /**
   * @return An ADAL user profile object.
   */
  getUserProfile () {
    return this.authenticationContext.getCachedUser().profile
  },
  async signIn () {
    if (!this.hasUserFile()) await this.initContext()
    this.setAfterLoginToUrl()
    this.authenticationContext.login()
  },
  signOut () {
    this.authenticationContext.logOut()
  },
}
